import styled from 'styled-components'

export const Username = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 10px;
    padding-right: 10px;
`;